import { Component } from '@angular/core';
import { NavController, NavParams, MenuController, ToastController, Events } from 'ionic-angular';
import { AngularFire } from 'angularfire2';
import { GlobalConfig } from '../../app/app.config';
import { LoginPage } from '../login/login';
import { ClientPage } from '../client/client';
import { ClientData } from '../../providers/client';
import { EventData } from '../../providers/event';
import { AuthData } from '../../providers/auth';
import { Translate} from '../../providers/translate';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';
import * as firebase from 'firebase';

@Component({
  selector: 'page-landing',
  templateUrl: 'landing.html'
})

export class LandingPage {

  message: any;
  navigatePrivate: any = false;
  eventList: any;
  urlClient: any;
  isCacheClient: any = false;
  timeLoad: number = 1;
  textTranslate: any;

  constructor(public navCtrl: NavController, params: NavParams, public clientProvider: ClientData, public eventProvider: EventData, public af: AngularFire, public auth: AuthData, public menuCtrl: MenuController, public events: Events, public storage: Storage, public toast: ToastController, public translateProvider: TranslateService, translate: Translate) {
     translate.translateGroup(['No es posible establecer la conexión sobre un navegador privado. Por favor deshabilite la conexión privada y vuelva a intentarlo más tarde', 'Esto está tardando demasiado', 'Ha pasado bastante tiempo', 'Al parecer tiene un problema de conexión'])
    .then(result => {
      this.textTranslate = result;
    });

    // Load client url
    this.urlClient = params.get('url');

    if (GlobalConfig._isOneClient) {
      this.urlClient = GlobalConfig._isOneClient;
      this.searchClient();
    } else {
      // Get client inside local storage
      if (this.urlClient && this.urlClient != ':url') {
        this.searchClient();
      } else {
        this.storage.get("cacheClient").then(data => {
          if (data) {
            this.urlClient = data;
            this.isCacheClient = true;
          }

          this.searchClient();
        });
      }
    }

    if (!GlobalConfig._debugMode) {
      let storageTestKey = 'sTest'
      let st: any = window.sessionStorage;

      try {
        st.setItem(storageTestKey, 'test');
        st.removeItem(storageTestKey);
      } catch (e) {
        if (e.code === DOMException.QUOTA_EXCEEDED_ERR && st.length === 0) {
          // private mode
          this.navigatePrivate = true;
          let toast = this.toast.create({
            message: this.textTranslate['No es posible establecer la conexión sobre un navegador privado. Por favor deshabilite la conexión privada y vuelva a intentarlo más tarde']
          });
          toast.present();
        } else {
          throw e;
        }
      }
    }
  }

  searchClient() {
    setTimeout(() => {
      if (!this.urlClient) {
        this.navCtrl.setRoot(ClientPage);
      } else {
        this.clientProvider.searchClient(this.urlClient, 'url')
        .then((result: any) => {

          this.translateProvider.setDefaultLang(result.defaultLang || GlobalConfig._defaultLang);
          this.storage.get("defaultLanguage").then(data => {
            if (data) {
              this.translateProvider.setDefaultLang(data);
            } else {
              this.translateProvider.setDefaultLang(result.defaultLang || GlobalConfig._defaultLang);
            }
          });

          this.validateClient(result);
        })
        .catch((error) => {
          // console.log("Error al buscar el cliente", error, this.urlClient)
          // this.storage.clear();
          this.navCtrl.setRoot(ClientPage);
          // if (!this.isCacheClient) {
          //   this.navCtrl.setRoot(ClientPage);
          // } else {
          //   this.searchClient();
          // }
        });
      }
    });
  }

  validateClient(client) {
    if (!client.state)
      this.navCtrl.setRoot(ClientPage);

    this.af.auth.subscribe( user => {

      setTimeout(() => {
        // Actualizaciones y listeners del usuario
        this.events.publish('client:login', user);
      }, 5000);

      if (user) {
        if (client.permissions.loginBlocked && user.anonymous) {
          if (this.eventList) {
            this.eventList = null;
          }
          this.auth.logoutUser();

          this.navCtrl.setRoot(LoginPage, {client: client, redirect: 'event'});
        } else {
          this.storage.set("cacheClient", this.urlClient);
          this.connection(client);
          if (!this.eventList) {
            this.eventList = this.eventProvider.getListEvents(client);
            this.events.publish('client:list-events', this.eventList, client);
          }
        }
      } else {
        this.eventList = null;
        this.storage.set("cacheClient", this.urlClient);

        if (client.permissions.loginBlocked) {
          this.navCtrl.setRoot(LoginPage, {client: client, redirect: 'event'});
        } else {
          this.auth.anonymousLogin();
        }
      }
    });
  }

  ionViewDidLoad() {
    setTimeout(() => {
      this.message = this.textTranslate['Esto está tardando demasiado'] + '...';
      this.timeLoad = 1;
      setTimeout(() => {
        this.message = this.textTranslate['Ha pasado bastante tiempo'] + '...';
        this.timeLoad = 2;
        setTimeout(() => {
          this.message = this.textTranslate['Al parecer tiene un problema de conexión'];
          this.timeLoad = 3;
        }, 5000);
      }, 5000);
    }, 7000);
  }

  reset() {
    window.location.reload();
  }

  connection(client) {
    let user = this.auth.getUser();
    let counterConnect = firebase.database().ref('/Clients/' + client.id + '/___connections/' + user.uid + '/state');
    // let lastOnlineUser = firebase.database().ref('/Clients/' + client.id + '/Users/' + user.uid);
    let connectedRef = firebase.database().ref('.info/connected');

    connectedRef.on('value', function(snap) {
      if (snap.val() === true) {
        counterConnect.set(true);
        counterConnect.onDisconnect().set(false);

        // if (!user.isAnonymous) {
        //   lastOnlineUser.child('isOnline').set(true);
        //   lastOnlineUser.child('isOnline').onDisconnect().set(false);
        //   lastOnlineUser.child('lastOnline').onDisconnect().set(firebase.database.ServerValue.TIMESTAMP);
        // }
      } else {
        console.log('No existe conexión');
      }
    });
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/landing/landing.ts